<template>
  <b-container style="position:relative" id="page-wrap">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <transition name="fade">
      <div class="theory_block" v-if="theory_open">
        <div class="theory_inner">
          <div class="cl_theory" @click.prevent.stop="theory_open=false" style="cursor:pointer">
            <i class="las la-times"></i>
          </div>
          <b-container>
            <template v-if="theories.length>0">
              <div class="row" style="padding-top:60px;">
                <b-col sm="12" md="4" class="theory_blocks">
                  <ul>
                    <template v-for="(item, index) in theories">
                      <li
                        :key="item.id"
                        :class="{active: index == cur_th}"
                        @click="cur_th=index"
                      >{{item.name}}</li>
                    </template>
                  </ul>
                </b-col>
                <b-col sm="12" md="8">
                  <template v-for="item in theories[cur_th].theory_set">
                    <div class="theory_bl" :key="item.sequence_no">
                      <div class="theory_header">{{item.name}}</div>
                      <div class="theory_body" v-html="item.text"></div>
                    </div>
                  </template>
                </b-col>
              </div>
            </template>
            <template v-else>
              <div class="row" style="padding-top:60px;">
                <b-col sm="12" md="12" class="theory_blocks">Вы пока что не прошли теории.</b-col>
              </div>
            </template>
          </b-container>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="theory_block" v-if="notification_open">
        <div class="theory_inner">
          <div class="cl_theory" @click.prevent.stop="notification_open=false" style="cursor:pointer">
            <i class="las la-times"></i>
          </div>
          <b-container style="padding-top:60px;">
            <template v-if="notifications.length>0 || ch_notifications.length>0">
              
                  <template v-for="(item,index) in ch_notifications">
                    <div class="row notification" :key="item.id">
                      <b-col sm="12" md="10" >
                        <Story
                          :name="item.parent_message.author.last_name + ' ' + item.parent_message.author.first_name"
                          :img="'//api.game.skillslab.center' + item.parent_message.author.avatar"
                          :role="item.parent_message.author.social_role"
                          :story="item.parent_message.text.replace('%name%', user.first_name).replace('%surname%', user.last_name)"
                          :button="false"
                          :data="item.parent_message"
                          style="margin-bottom:10px;"
                        ></Story>
                        
                      </b-col>
                      <b-col sm="12" class="person" style="margin-bottom:20px;">
                          <img src="@/assets/question.svg" alt style="fill:rgb(75, 201, 219);" />
                          <div class="user">
                            <div class="name" v-html="item.open_question.text"></div>
                            <div class="role">Задание</div>
                          </div>
                      </b-col>
                      <b-col sm="12" md="10" >
                        <Story
                          :name="user.last_name + ' ' + user.first_name"
                          :img="'//api.game.skillslab.center' + user.icon"
                          role="Это Вы"
                          :story="item.open_answer.text"
                          :button="false"
                          :data="item.open_answer"
                          style="margin-bottom:20px; margin-left:70px"
                          
                        ></Story>
                        
                      </b-col>
                      <b-col sm="12" md="10" >
                        <Story
                          name="Клименко Юрий"
                          img="http://api.game.skillslab.center/media/avatars/klimenko.jpg"
                          role="Автор курса"
                          :story="item.text"
                          :button="false"
                          style="margin-bottom:20px;"
                          class="result only"
                        ></Story>
                        
                      </b-col>
                      <b-col sm="12" md="10" style="margin-bottom:20px;">
                        <div style="display:table; margin-left:70px; font-size:24px;">
                          <b-button
                            @click="ch_notification_complete(index)"
                            variant="primary"
                          >
                          Удалить уведомление
                          </b-button>
                        </div>
                      </b-col>
                    </div>
                  </template>
                  <template v-for="(item,index) in notifications">
                    <div class="row notification" :key="item.id">
                      <b-col sm="12" md="10" >
                        <Story
                          :name="item.parent_message.author.last_name + ' ' + item.parent_message.author.first_name"
                          :img="'//api.game.skillslab.center' + item.parent_message.author.avatar"
                          :role="item.parent_message.author.social_role"
                          :story="item.parent_message.text.replace('%name%', user.first_name).replace('%surname%', user.last_name)"
                          :button="false"
                          :data="item.parent_message"
                          style="margin-bottom:10px;"
                        ></Story>
                        
                      </b-col>
                      <b-col sm="12" class="person" style="margin-bottom:20px;">
                          <img src="@/assets/question.svg" alt style="fill:rgb(75, 201, 219);" />
                          <div class="user">
                            <div class="name" v-html="item.open_question.text"></div>
                            <div class="role">Задание</div>
                          </div>
                      </b-col>
                      <b-col sm="12" md="10" >
                        <Story
                          :name="user.last_name + ' ' + user.first_name"
                          :img="'//api.game.skillslab.center' + user.icon"
                          role="Это Вы"
                          :story="item.open_answer.text"
                          :button="false"
                          :data="item.open_answer"
                          style="margin-bottom:20px; margin-left:70px"
                          
                        ></Story>
                        
                      </b-col>
                      <b-col sm="12" md="10" >
                        <Story
                          :name="item.author.last_name + ' ' + item.author.first_name"
                          :img="'//api.game.skillslab.center' + item.author.avatar"
                          role="Комментарий пользователя"
                          :story="item.text"
                          :button="false"
                          style="margin-bottom:20px;"
                          class="result only"
                        ></Story>
                        
                      </b-col>
                      <b-col sm="12" md="10" style="margin-bottom:20px;">
                        <div style="display:table; margin-left:70px; font-size:24px;">
                          <h4 style="display:inline">Оцените комментарий:</h4>
                          <star-rating
                            class="mb-4"
                            :show-rating="false"
                            :star-size="36"
                            active-color="#08a2dc"
                            :rating = 0
                            @rating-selected ="setrating($event, item.id, index)"
                            style="margin-bottom: 0 !important;   margin-top:10px;display:inline"
                          ></star-rating>
                        </div>
                      </b-col>
                    </div>
                  </template>
                
              
            </template>
            <template v-else>
              <div class="row" style="padding-top:60px;">
                <b-col sm="12" md="12" class="theory_blocks">У вас нет уведомлений.</b-col>
              </div>
            </template>
          </b-container>
        </div>
      </div>
    </transition>

    <Title :number="content.sequence_no" :title="content.name"></Title>
    <Slide
      :isOpen="slideIsOpen"
      @openMenu="openSlide"
      @closeMenu="closeSlide"
      :burgerIcon="false"
      right
      Animation="push"
    >
      <template v-if="this.slide_type == 1">
        <template v-for="(page,index) in content.lession_pages">
          <a
            :key="page.id"
            id="home"
            @click="goto(page.id)"
            style="cursor:pointer"
            :class="{active_page: page.id == content.id}"
            v-if="page.active"
          >
            <span>{{index +1}}. {{page.name}}</span>
          </a>
          <a :key="page.id" id="home" style="cursor:not-allowed" v-else>
            <span style="color:#ddd">{{index +1}}. {{page.name}}</span>
          </a>
        </template>
      </template>

      
    </Slide>

    <div class="nav_block">
      <div
        class="pages"
        v-b-tooltip.hover
        title="К последнему сообщению"
        @click.stop.prevent="to_top(to_message)"
        v-if="!content.is_onboarding  && to_message > 0 && !content.complete"
      >
        <i class="las la-arrow-up" style="padding:13px; font-size:34px;"></i>
      </div>
      
      
      <div
        class="pages"
        v-b-tooltip.hover
        title="Оглавление"
        @click.stop.prevent="toggleSlide(1)"
        v-if="!content.is_onboarding"
      >
        <vue-circle
        ref="progress_circle"
        :progress="0"
        :size="60"
        :reverse="false"
        line-cap="round"
        empty-fill="rgba(0, 0, 0, .1)"
        :animation-start-value="0.0"
        :start-angle="0"
        insert-mode="append"
        :thickness="5"
        
       >
          
      </vue-circle >
        <i class="las la-bars" style="padding:13px; font-size:34px;"></i>
      </div>
      <div
        class="pages"
        v-b-tooltip.hover
        title="Теория"
        @click.stop.prevent="open_theory"
        v-if="!content.is_onboarding"
      >
        <i class="las la-book-open" style="padding:13px; font-size:34px;"></i>
      </div>
      <div
        class="pages"
        v-b-tooltip.hover
        title="Уведомления"
        @click.stop.prevent="n_open"
        v-if="!content.is_onboarding"
        style="position:relative"
      >
        <i class="las la-bell" style="padding:13px; font-size:34px;"></i>
        <div class="n_count" v-if="notifications.length + ch_notifications.length>0">{{notifications.length + ch_notifications.length}}</div>
      </div>
    </div>
    <template v-for="(item, index) in content.place_set">
      <transition name="fade" :key="item.id">
        <Story
          class="mb-40"
          @answered="get_data"
          :id="'story'+index"
          v-if="item.content_object.type == 'message'"
          :name="item.content_object.author.last_name + ' ' + item.content_object.author.first_name"
          :img="'//api.game.skillslab.center' + item.content_object.author.avatar"
          :role="item.content_object.author.social_role"
          :story="item.content_object.text.replace('%name%', user.first_name).replace('%surname%', user.last_name)"
          :button="index==content.place_set.length-1&&!content.complete"
          :page="page"
          :data="item.content_object"
        ></Story>
        <Question
          :id="'story'+index"
          @answered="get_data1"
          class="mb-40"
          :key="item.id"
          v-if="item.content_object.type == 'question'"
          :question="item.content_object.text"
          :answers="item.content_object.answer_set"
          :result="item.content_object.result?item.content_object.result.replace('%name%', user.first_name).replace('%surname%', user.last_name):''"
          :time="item.content_object.time_to_answer"
          :data="item.content_object"
        ></Question>
        <OpenQuestion
          :id="'story'+index"
          @answered="get_data1"
          class="mb-40"
          :key="item.id"
          v-if="item.content_object.type == 'open_question'"
          :question="item.content_object.text"
          :result="item.content_object.postreply_text"
          :data="item.content_object"
        ></OpenQuestion>
        <Theory
          :id="'story'+index"
          v-if="item.content_object.type == 'theory'"
          :story="item.content_object.text"
          :page="page"
          class="mb-40"
          :name="item.content_object.name"
          :button="index==content.place_set.length-1&&!content.complete"
          :data="item.content_object"
          @answered="get_data"
        ></Theory>

        <div class="row" v-if="item.content_object.type == 'safe_text'" :id="'story'+index">
          <div
            class="col-10 safe"
            v-html="item.content_object.text"
            style="padding-left: 95px; margin-bottom:10px; font-weight:bold"
          ></div>
        </div>
      </transition>
    </template>
    <transition name="fade">
      <end
        :page="page"
        :onboarding="content.is_onboarding"
        :fun="content.user_fun"
        :utility="content.user_utility"
        v-if="content.complete"
        @end="endpage"
        id="end"
      ></end>
    </transition>
    <div class="whitespace" style="height:50px; width:100%;"></div>

    <!-- <OpenQuestion question='Увидел, что в чате проекта проишло вот то-то. Как думаешь, нужно ли на это реагировать?'></OpenQuestion>  -->
  </b-container>
</template>

<script>
// @ is an alias to /src
import VueCircle from 'vue2-circle-progress/src/index.vue'
import Important from "@/components/Important.vue";
import Title from "@/components/Title.vue";
import Question from "@/components/Question.vue";
import Person from "@/components/Person.vue";
import Story from "@/components/Story.vue";
import Theory from "@/components/Theory.vue";
import OpenQuestion from "@/components/OpenQuestion.vue";
import End from "@/components/End.vue";
import API from "@/api";
import { Slide } from "vue-burger-menu";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import StarRating from "vue-star-rating";


export default {
  name: "Home",
  components: {
    VueCircle,
    Important,
    Title,
    Question,
    Person,
    Story,
    Theory,
    OpenQuestion,
    End,
    Slide,
    Loading, 
    StarRating
  },
  data: function() {
    return {
      content: {},
      user: this.$store.getters.userData,
      page: this.$store.getters.currentPage,
      scroll: false,
      blocks: 0,
      slideIsOpen: false,
      slide_type: 0,
      theories: [],
      notifications: [],
      ch_notifications: [],
      c_scroll: false,
      c_scroll_to: 0,
      cur_th: 0,
      theory_open: false,
      return_scroll: false,
      isLoading: false, 
      notification_open: false
    };
  },
  computed: {
  // геттер вычисляемого значения

  progress_data:function(){
    if(this.content.place_set)
    {
       return parseInt(this.content.place_set.length/this.content.place_set_count*100, 10)
    }
    return 0;
  },
  to_message: function () {
      if(this.content.place_set)
      {
        if(this.content.place_set[this.content.place_set.length-1].content_object.type == 'question' || this.content.place_set[this.content.place_set.length-1].content_object.type == 'open_question')
        {
    
          for(var i = this.content.place_set.length - 1; i>=0; i--)
          {

            if(this.content.place_set[i].content_object.type == 'message')
            {
              return i
            }
          }
          return 0;
          
          return this.content.place_set[this.content.place_set.length-1].sequence_no
        }
        else{
          return 0;
        }
      }
      else{
        return 0;
      }
    }
  },
  mounted() {
    
    this.isLoading = true
    const user = this.$store.getters.userData;
    if (user.first_name == null || user.icon == null || user.icon == "") {
      this.$router.push("/makeUser");
    }
    else{

    
      const current = this.$store.getters.currentPage;
      this.page = this.$store.getters.currentPage;
      if (current != null && current != 0) {
        this.$store.dispatch("user_data")
        this.first_data()
        this.$gtag.pageview({
          page_path: '/page/'+current,
        })
         
        
      } else {
        
        this.$router.push("/courses");
      }
    }
  },
  methods: {
    to_top(i)
    {

      this.$scrollTo("#story" + i, 1200, { easing: "linear" });
    },
  
    open_theory() {
      this.get_theory();
      this.theory_open = true;

    },
    n_open()
    {
      this.notification_open = true
    },
    get_notifications() {
      API.get("api/new_comments/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`
        }
      }).then(response => {

        this.ch_notifications = response.data.character_comments;
        this.notifications = response.data.user_comments;
      })
      .catch(function (error) {
        if(error.response.status == 404)
        {
          this.$router.push("/courses");
        }
        if(error.response.status == 401)
        {
          this.$store.dispatch("logout");
            
        }

      }.bind(this));
    },
    get_theory() {
      API.get("api/user_theory_chapters/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`
        }
      }).then(response => {
        this.theories = response.data;
      });
    },
    goto(id) {

      this.isLoading = true;
      this.closeSlide();
      this.$store.commit("setPage", { page: id, onboarding: true });
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` }
      };
      const data = new FormData();
      data.append("page", id);
      API.post("api/set_current_page/", data, config).then(response => {
        this.page = id;

        this.first_data();
      })
      .catch(function (error) {
        if(error.response.status == 404)
        {
          this.$router.push("/courses");
        }
        if(error.response.status == 401)
        {
          this.$store.dispatch("logout");
            
        }

      }.bind(this));
    },
    openSlide() {
      this.slideIsOpen = true;
    },
    closeSlide() {
      this.slideIsOpen = false;
    },
    toggleSlide(i) {
      if (i == 3 && this.notifications.length == 0&& this.ch_notifications.length == 0) {
      } else {
        this.slide_type = i;
        this.slideIsOpen = !this.slideIsOpen;
      }
    },
    endpage() {
      if (this.content.is_onboarding || !this.content.next_page) {
        this.$store.commit("setPage", { page: 0, onboarding: true });

        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` }
        };
        const data = new FormData();
        data.append("page", 0);
        API.post("api/set_current_page/", data, config).then(response => {
          this.$router.push({ path: "/courses" });
        })
        .catch(function (error) {
          if(error.response.status == 404)
          {
            this.$router.push("/courses");
          }
          if(error.response.status == 401)
          {
            this.$store.dispatch("logout");
              
          }

        }.bind(this));
      } else {
        this.$store.commit("setPage", {
          page: this.content.next_page,
          onboarding: true
        });
        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` }
        };
        const data = new FormData();
        data.append("page", this.content.next_page);
        API.post("api/set_current_page/", data, config).then(response => {
          this.page = this.content.next_page;
          this.first_data();
        })
        .catch(function (error) {
        if(error.response.status == 404)
        {
          this.$router.push("/courses");
        }
        if(error.response.status == 401)
        {
          this.$store.dispatch("logout");
            
        }

      }.bind(this));
      }
    },
    onSubmit() {
      this.$store.dispatch("logout");
    },
    ch_notification_complete(index) {
      const value = this.ch_notifications[index]["id"];
      var array = this.ch_notifications;
      const temp = array.splice(index, 1);
      this.ch_notifications = array;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` }
      };
      API.post(
        "api/mark_comment_seen/",
        { character_comment: value },
        config
      ).then(response => {});
    },
    notification_complete(index) {

      const value = this.notifications[index]["id"];
      var array = this.notifications;
      const temp = array.splice(index, index+1);
      this.notifications = array;
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` }
      };
      API.post(
        "api/mark_comment_seen/",
        { comment: value },
        config
      ).then(response => {});
    },


    setrating(value, id, index)
    {
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` }
      };
      const data = new FormData();
      data.append("comment", id);
      data.append("score", value);
      API.post("api/score_comment/", data, config).then(response => {
        this.notification_complete(index);
      });
    },
    first_data()
    {
      const data = new FormData();
      data.append("page", this.page);
      API.get("api/page/" + this.page + "/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`
        }
      }).then(response => {
        
        this.content = response.data;
        this.$refs.progress_circle.updateProgress(this.progress_data);

        this.isLoading = false;
        if (response.data.place_set.length > this.blocks) {
          this.blocks = response.data.place_set.length;
          this.scroll = true;
        } else {
          this.blocks = response.data.place_set.length;
          this.scroll = false;
        }
        if (
          (response.data.complete && response.data.user_fun) ||
          this.blocks == -1
        ) {
          this.blocks = -1;
          this.scroll = false;
        }
        if (
          response.data.complete &&
          !response.data.user_fun &&
          this.blocks != -1
        ) {
          this.blocks = -1;
          this.scroll = true;
        }
        this.get_notifications();
         this.get_theory();
      }).catch(function (error) {

        if(error.response.status == 404)
        {
          this.$router.push("/courses");
        }
        if(error.response.status == 401)
        {
          this.$store.dispatch("logout");
            
        }
      }.bind(this));
    },
    get_data() {
      const data = new FormData();
      data.append("page", this.page);
      API.get("api/page_offset/" + this.page + '/' + this.content.place_set[this.content.place_set.length - 1].sequence_no + "/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`
        }
      }).then(response => {
 
        var new_page = this.content.place_set
        new_page.pop()
        new_page = new_page.concat(response.data.place_set)
        this.content.place_set = new_page
        this.content.complete = response.data.complete
        
        if(!response.data.is_onboarding)
        {
          this.$refs.progress_circle.updateProgress(this.progress_data);
        }
        

        this.isLoading = false;
        if (new_page.length > this.blocks) {
          this.blocks = new_page.length;
          this.scroll = true;
        } else {
          this.blocks = new_page.length;
          this.scroll = false;
        }
        if (
          (response.data.complete && response.data.user_fun) ||
          this.blocks == -1
        ) {
          this.blocks = -1;
          this.scroll = false;
        }
        if (
          response.data.complete &&
          !response.data.user_fun &&
          this.blocks != -1
        ) {
          this.blocks = -1;
          this.scroll = true;
        }
      }).catch(function (error) {

        if(error.response.status == 404)
        {
          this.$router.push("/courses");
        }
        if(error.response.status == 401)
        {
          this.$store.dispatch("logout");
            
        }
      }.bind(this));
    },
    get_data1() {

      const data = new FormData();
      data.append("page", this.page);
      API.get("api/page_offset/" + this.page + '/' + this.content.place_set[this.content.place_set.length - 1].sequence_no + "/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`
        }
      }).then(response => {
        (response.data)
        var new_page = this.content.place_set
        new_page.pop()
        new_page = new_page.concat(response.data.place_set)
        this.content.place_set = new_page
        this.content.complete = response.data.complete
        if(!response.data.is_onboarding)
        {
          this.$refs.progress_circle.updateProgress(this.progress_data);
        }
        this.isLoading = false;
        this.scroll = false;
        
      }).catch(function (error) {

        if(error.response.status == 404)
        {
          this.$router.push("/courses");
        }
        if(error.response.status == 401)
        {
          this.$store.dispatch("logout");
            
        }

      }.bind(this));
    }
  },
  updated: function() {
    this.$nextTick(function() {
      if (this.return_scroll) {
        this.$scrollTo("#page-wrap", 1200, { easing: "linear" });
        this.return_scroll = false;
      } else {
        if (this.c_scroll) {
          setTimeout(
            function() {

              this.$scrollTo("#story" + this.c_scroll_to, 1200, {
                easing: "linear"
              });
              this.c_scroll = false;
              this.c_scroll_to = 0;
            }.bind(this),
            1000
          );
        } else {
          if (this.scroll) {
            if (this.blocks == -1) {
              this.$scrollTo("#end", 1200, { easing: "linear" });
            } else {
              let blocks = this.blocks - 1;
              this.$scrollTo("#story" + blocks, 1200, { easing: "linear" });
            }
            this.scroll = false;
          }
        }
      }
    });
  }
};
</script>
<style >
.safe > p:last-child {
  margin-bottom: 0 !important;
}
.safe > p {
  font-size: 18px;
}
.mb-40 {
  margin-bottom: 40px;
}
.fade-enter-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.pages {
  -webkit-transition: background 0.35s, box-shadow 0.5s, -webkit-transform 0.5s;
  transition: background 0.35s, box-shadow 0.5s, -webkit-transform 0.5s;
  transition: transform 0.5s, background 0.35s, box-shadow 0.5s;
  transition: transform 0.5s, background 0.35s, box-shadow 0.5s,
    -webkit-transform 0.5s;
  box-shadow: 0 5px 20px 1px rgba(0, 0, 0, 0.15);
  background: #fff;
  color: #08a2dc;
  cursor: pointer;
  font-size: 24px;
  margin-top: 10px;

  height: 60px;
  width: 60px;
  border-radius: 30px;
}
.nav_block {
  z-index: 2;
  position: fixed;
  right: 40px;
  bottom: 100px;
}
.active_page span {
  color: #08a2dc !important;
}
.n_count {
  top: 0;
  right: 0;
  background-color: red;
  font-size: 6px;
  padding: 5px 7px;
  border-radius: 20px;
  position: absolute;
  display: table;
  color: white;
}
.cl_not {
  position: absolute;
  top: 0;
  right: 0;
  color: white;
  margin-right: 10px;
  margin-top: -5px;
  cursor: pointer;
}
.theory_block {
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  position: fixed;
  z-index: 100;
}
.theory_inner {
  background-color: white;
  margin: 30px;
  height: calc(100% - 60px);
  position: relative;
  overflow: scroll;
}
.cl_theory {
  font-size: 24px;
  margin-left: 20px;
  margin-top: 20px;
  position: fixed;
  z-index: 999;
}

.theory_header {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}
.theory_blocks ul {
  padding: 0;
}
.theory_blocks li {
  list-style: none;
  padding: 15px 0 15px 10px;
  background-color: #f3f3f3;
  border-bottom: 1px white solid;
  cursor: pointer;
}

.theory_blocks li:last-child {
  border: none;
}
.theory_blocks li.active {
  background-color: #08a2dc;
  color: white;
}
.illustration {
  float: left;
  margin-right: 10px;
  width: 240px;
  max-width: 100%;
  margin-top:7px;
}
p{
  word-break: break-word !important;
}
body .theory_header
{
  font-family: "Open Sans";
  font-weight: bold;
}
.theory_body
{
  display: table;
  margin-bottom: 15px;
}
hr{
  color: white;
  border-color: white;
  padding-bottom: 0 !important;
  margin-bottom: 5px;;
}
.circle-percent-text-body
{
  display: none !important;
}
.circle
{
  position: absolute !important;
  background-color: transparent;
}
.only.result{
  margin-left: 70px !important ;
  padding-left: 15px;
}
.notification{
  border-bottom: 3px #eee solid;
  margin-bottom: 40px;
  padding-bottom: 10px;
}
@media (max-width: 1199px) { 
  .pages
  {
    height: 40px;
    width: 40px;
  }
  .pages i 
  {
    padding: 10px !important;
    font-size: 20px !important;
  }
  .nav_block{
    bottom: 50px !important;
    left:40px;
    right: unset;
  }  
  .circle canvas
  {
    width: 40px !important;
    height: 40px !important;
  }

 }
</style>